<script>
export default {
  name: 'AdminUnclassifiedSitesTable',
  props: {
    sites: Array
  },
  methods: {
    classify(site, classification) {
      this.$http.put(`/admin/sites/unclassified/${site.id}`, { classification })
        .then(() => this.$emit('update', site))
        .catch(err => {
          this.$notify({
            type: 'error',
            title: 'Error',
            message: err.message
          });
        });
    }
  }
};
</script>

<template>
  <table v-if="sites.length" class="table">
    <thead>
      <tr>
        <th>Site</th>
        <th class="hidden-sm-and-down">Created</th>
        <th />
      </tr>
    </thead>
    <tbody>
      <tr v-for="(site, index) in sites" :key="index">
        <td>
          {{ site.name }}<br>
          <small>
            <a :href="site.url" target="_blank">
              {{ site.url }}
            </a><br>
            <span class="text-muted">
              <i class="el-icon-fa-hashtag" />{{ site.accountId }}
            </span>
          </small>
        </td>
        <td class="hidden-sm-and-down">
          {{ $d(new Date(site.createdAt), 'short') }}<br>
        </td>
        <td>
          <el-dropdown trigger="click">
            <el-button size="small">
              Classify <i class="el-icon-fa-chevron-down el-icon--right" />
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="classify(site, 'personal')">
                Personal
              </el-dropdown-item>
              <el-dropdown-item @click.native="classify(site, 'educational')">
                Educational
              </el-dropdown-item>
              <el-dropdown-item @click.native="classify(site, 'non-profit')">
                Non-profit
              </el-dropdown-item>
              <el-dropdown-item divided @click.native="classify(site, 'staging')">
                Staging
              </el-dropdown-item>
              <el-dropdown-item @click.native="classify(site, 'unreachable')">
                Unreachable
              </el-dropdown-item>
              <el-dropdown-item divided @click.native="classify(site, 'commercial')">
                Commercial
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </td>
      </tr>
    </tbody>
  </table>

  <div v-else class="no-sites">
    No Unclassified Sites
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.no-sites {
  font-size: 1.2rem;
  text-align: center;
  color: $--color-gray-40;
  padding: 5rem 0;
}
</style>
